WiseMetering.Views.ShowContazaraConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/contazara/show',
    title: () => i18next.t('modal.title.integration_configurations.show')

    // edit: function() {
    //     new WiseMetering.Views.EditContazaraConfiguration({ model: this.model });
    // }
});
